import { GOLDEN_TOWER, BLACK_HOLE } from 'utils/constants';

const SmartMissiles = ({ unlocked, currentCount, showAll }) => (
  <div className='weapon'>
    {!showAll && <div className='title'>You should pick Smart Missiles</div>}
    {showAll && <div className='title'>Smart Missiles</div>}
    {!showAll && unlocked[GOLDEN_TOWER] && unlocked[BLACK_HOLE] && (
      <div className='info'>
        Do not pick this yet until you sync Golden Tower and Black Hole.
      </div>
    )}
    {(showAll || !unlocked[BLACK_HOLE]) && (
      <div className='info'>
        Keep looking for Black Hole before building this.
      </div>
    )}
  </div>
);

export default SmartMissiles;
